//
//
//
//
//
//

export default {
  name: 'GridViewLabel'
}
